(() => {
  if(window.vitalShoppingActions)return;
  window.vitalShoppingActions=true;
  const configNode=document.querySelector('[data-essentials-config]');
  if(!configNode)return;
  const config=JSON.parse(configNode.textContent),t=config.shopping;
  if(!t)return;
  const key=`vital-essentials-preview-v2:${config.theme}`;
  let busy=false;
  const read=()=>{const entries=JSON.parse(localStorage.getItem(key)||'[]');if(!Array.isArray(entries))throw new Error(t.cart_unavailable);return entries;};
  const request=async(url,options={})=>{
    const response=await fetch(url,{credentials:'same-origin',...options,headers:{Accept:'application/json',...options.headers},signal:AbortSignal.timeout(25000)});
    const data=await response.json();
    if(!response.ok || data.ok===false || data.status>=400)throw new Error(data.description||data.error||t.error);
    return data;
  };
  const say=(root,text,success=false)=>{const status=root.querySelector('[data-shopping-status]');if(status){status.textContent=text;status.classList.toggle('is-success',success);}};
  const cartCount=cart=>{
    let extras=0;try{extras=read().filter(entry=>entry&&typeof entry.id==='string'&&Array.isArray(entry.items)&&entry.items.length).length;}catch{}
    document.querySelectorAll('.cart-count').forEach(badge=>{badge.textContent=String(cart.item_count+extras);});
    window.dispatchEvent(new CustomEvent('vital:cart-updated',{detail:{cart}}));
  };
  const checkout=notify=>new Promise((resolve,reject)=>{
    if(!document.querySelector('[data-essentials-config]')){reject(new Error(t.error));return;}
    window.dispatchEvent(new CustomEvent('vital:checkout',{detail:{prelaunch:false,notify,resolve,reject}}));
  });
  const addOrdinary=async(form,buyNow=false)=>{
    if(busy){say(form,t.checking);return;}
    if(!form.reportValidity())return;
    const button=form.querySelector('[name=add]');
    if(!button || button.disabled)return;
    const body=new FormData(form),id=String(body.get('id')||''),quantity=Number(body.get('quantity')||1);
    if(!/^\d+$/.test(id)||!Number.isSafeInteger(quantity)||quantity<1){say(form,t.choose_notice);return;}
    busy=true;
    const mirrors=form.id?[...document.querySelectorAll(`[form="${CSS.escape(form.id)}"][data-sticky-add]`)]:[];
    const controls=[...form.querySelectorAll('input,select,button'),...mirrors].map(control=>[control,control.disabled]);
    controls.forEach(([control])=>{control.disabled=true;});button.setAttribute('aria-busy','true');button.textContent=t.adding;say(form,'');
    let added=false;
    try{
      await request(`${config.root||'/'}cart/add.js`,{method:'POST',body});
      added=true;button.classList.add('is-added');button.textContent=t.added;mirrors.forEach(mirror=>{mirror.textContent=t.added;mirror.classList.add('is-added');});say(form,t.added_notice,true);
      const cart=await request(`${config.root||'/'}cart.js`);cartCount(cart);
      if(buyNow){say(form,t.checking);await checkout(text=>say(form,text));}
    }catch(error){say(form,error instanceof TypeError || error.name==='TimeoutError' ? t.error : error.message||t.error);}
    finally{busy=false;controls.forEach(([control,disabled])=>{control.disabled=disabled;});button.removeAttribute('aria-busy');button.textContent=added?t.added:t.add;}
  };
  const addEssentials=async(card)=>{
    const button=card.querySelector('[data-essential-card-add]');
    if(!button||button.disabled)return;
    if(busy){say(card,t.checking);return;}
    busy=true;button.disabled=true;button.setAttribute('aria-busy','true');button.textContent=t.adding;say(card,t.checking);
    let saved=false;
    try{
      const starting=JSON.parse(card.querySelector('[data-essential-card-selection]').textContent);
      const entry=read().find(item=>item.id===starting.id||item.definitionId===starting.definitionId)||starting;
      if(!entry || !entry.definitionId || !Number.isSafeInteger(entry.price)||entry.price<=0 || !Array.isArray(entry.items)||!entry.items.length||entry.items.length>12||entry.items.some(item=>!/^\d+$/.test(item.variant)))throw new Error(t.selection_change);
      let cartId=localStorage.getItem(`${key}:session`);
      if(!cartId){cartId=crypto.randomUUID();localStorage.setItem(`${key}:session`,cartId);}
      const quote=await request(`${config.proxy}/quote`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({cartId,cart:{currency:config.currency,promotionCode:'',hasDiscounts:false,hasSellingPlans:false,ordinary:[],essentials:[{groupId:entry.id,definitionId:entry.definitionId,variantIds:entry.items.map(item=>`gid://shopify/ProductVariant/${item.variant}`)}]}})});
      if(quote.subtotalCents!==entry.price||(quote.baseSubtotalCents??quote.subtotalCents)!==entry.price||(quote.discountCents??0)!==0)throw new Error(t.selection_change);
      const entries=read().filter(item=>item.id!==entry.id&&item.definitionId!==entry.definitionId);
      if(entries.length>=12)throw new Error(t.cart_unavailable);
      localStorage.setItem(key,JSON.stringify([...entries,entry]));saved=true;
      window.dispatchEvent(new Event('essentials:change'));
      button.classList.add('is-added');say(card,t.added_notice,true);
      const cart=await request(`${config.root||'/'}cart.js`);cartCount(cart);
    }catch(error){say(card,saved?t.added_notice:t.selection_change,saved);if(!saved)card.querySelector('.shopping-detail-fallback').hidden=false;}
    finally{busy=false;button.disabled=false;button.removeAttribute('aria-busy');button.textContent=saved?t.added:t.add;}
  };
  document.addEventListener('submit',event=>{
    const form=event.target.closest('form[data-shopping-form]');
    if(!form)return;
    event.preventDefault();addOrdinary(form);
  });
  document.addEventListener('click',event=>{
    const quick=event.target.closest('[data-essential-card-add]');
    if(quick){event.preventDefault();addEssentials(quick.closest('[data-essential-card]'));return;}
    const buy=event.target.closest('[data-shopping-buy-now]');
    if(buy){event.preventDefault();addOrdinary(buy.closest('form'),true);}
  });
  document.addEventListener('change',event=>{
    const form=event.target.closest('form[data-shopping-form]');
    if(!form)return;
    const button=form.querySelector('[name=add]');if(form.id)document.querySelectorAll(`[form="${CSS.escape(form.id)}"][data-sticky-add]`).forEach(mirror=>mirror.classList.remove('is-added'));button.classList.remove('is-added');button.textContent=t.add;say(form,'');
    if(event.target.matches('[data-card-variant]')){
      const card=form.closest('.product-card'),price=card.querySelector('.vital-card-price');
      price.textContent=event.target.selectedOptions[0].dataset.price||'';
    }
    const buy=form.querySelector('[data-shopping-buy-now]'),variant=form.querySelector('[data-variant-select]');
    if(buy&&variant)buy.disabled=button.dataset.prelaunch==='true'||variant.selectedOptions[0]?.dataset.available!=='true';
  });
})();

